import { injectIntl } from 'react-intl';
import { useEffect, useState } from 'react';
import { Modal, Select, Form } from 'antd';

import { getHubStars, getHubStarsByHubId } from 'services/hubs';
import { confirmLost } from 'services/ops-control';
import { formatOptions } from 'utils';
import { getCurrentUserHubInfo } from 'utils/hubs';

import BRButton from 'components/BRButton/BRButton';
import { notify } from 'components/Notify/Notify';

import { ReactComponent as AlertTriangleOutlined } from 'assets/bosta-icons/alert-triangle-outlined.svg';

import './StarIsLiableModal.less';

const FORM_ID = 'STAR_IS_LIABLE_FORM';

const StarIsLiableModal = ({
  intl,
  close,
  title,
  delivery,
  hubId,
  ...rest
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [starsList, setStarsList] = useState([]);
  const starFieldValue = Form.useWatch('star', form);

  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const currentUserScopes = userInfo?.scopes;

  const fetchHubStars = async () => {
    setIsLoading(true);

    try {
      const { message } = await getHubStars(hubId);
      setStarsList(message);
    } catch (error) {
      notify(error.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchHubStars();
  }, []);

  const onFinish = async (values) => {
    setIsLoading(true);

    const payload = {
      starId: values?.star
    };

    try {
      const res = await confirmLost(delivery?._id, {
        liabilityOn: 'STAR'
      });
      notify(res.message, 'success');
    } catch (error) {
      notify(error.message);
    } finally {
      setIsLoading(false);
      close();
    }
  };

  return (
    <Modal
      {...rest}
      footer={
        <div className="br-lost-or-damaged-modal__footer">
          <BRButton
            label={intl.formatMessage({ id: 'common.cancel' })}
            onClick={close}
          />
          <BRButton
            loading={isLoading}
            disabled={isLoading || !starFieldValue}
            type="primary"
            htmlType="submit"
            form={FORM_ID}
            label={intl.formatMessage({ id: 'common.confirm' })}
          />
        </div>
      }
      centered
      onCancel={close}
    >
      <div className="br-star-is-liable-modal-container">
        <div className="br-star-is-liable-modal-alert-triangle-container">
          <AlertTriangleOutlined className="br-star-is-liable-modal-alert-triangle" />
        </div>
        <div className="br-star-is-liable-modal-content">
          <span className="heading1">
            {intl.formatMessage({
              id: 'ops_control.lost_orders.star_liable_modal.title'
            })}
          </span>
          <span className="body">
            {intl.formatMessage({
              id: 'ops_control.lost_orders.star_liable_modal.description'
            })}
          </span>
        </div>
      </div>
      <Form
        onFinish={onFinish}
        form={form}
        id={FORM_ID}
        className="br-lost-modal__form-wrapper"
      >
        <Form.Item
          rules={[{ required: true }]}
          label={
            <span className="body-medium">
              {intl.formatMessage({
                id: 'ops_control.lost_orders.star_liable_modal.star'
              })}
            </span>
          }
          name="star"
          className="br-lost-modal__select-wrapper br-lost-modal__input-row"
        >
          <Select
            placeholder={intl.formatMessage({ id: 'common.select' })}
            allowClear
            showSearch
            showArrow
            getPopupContainer={(trigger) => trigger.parentElement}
            filterOption={(input, option) =>
              option.label
                .toString()
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0 ||
              option.value
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            options={
              formatOptions &&
              formatOptions(
                '_id',
                'profile.firstName,profile.lastName',
                starsList
              )
            }
            disabled={!starsList?.length}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default injectIntl(StarIsLiableModal);
